import React from 'react';
import styles from './styles.scss';

import useRxDispatch from '../../utils/use-rx-dispatch';

import {Button} from '@densityco/ui';
import {CaptureScheduleModalActionTypes, Page, PAGES_IN_ORDER,} from '../../types/capture-schedule-modal';

export const NextButton: React.FunctionComponent<{ page: Page, disabled?: boolean }> = ({page, disabled}) => {
  const dispatch = useRxDispatch();
  return (
      <Button
          variant="filled"
          disabled={disabled}
          onClick={() => {
            dispatch({
              type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_PAGE,
              page: PAGES_IN_ORDER[PAGES_IN_ORDER.indexOf(page) + 1],
            });
          }}
      >Next</Button>
  );
};

export const BackButton: React.FunctionComponent<{ page: Page }> = ({page}) => {
  const dispatch = useRxDispatch();
  return (
      <Button onClick={() => {
        dispatch({
          type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_PAGE,
          page: PAGES_IN_ORDER[PAGES_IN_ORDER.indexOf(page) - 1],
        });
      }}>Back</Button>
  );
};

export const LoadingBar: React.FunctionComponent<{ width?: React.ReactText }> = ({width = '100%'}) => (
    <div className={styles.wrapper} style={{width}}>
      <div className={styles.inner}/>
    </div>
);

export const CaptureWarning: React.FunctionComponent<{}> = () => (
    <div className={styles.captureWarning}>
      <h3>Warning - you are scheduling a lot of captures!</h3>
      <p>
        It looks like you're trying to schedule a lot of captures for these
        spaces. In order to configure the algorithm, we only need about 20 diverse
        events, which we can typically get from 10 captures. If you know that the
        space doesn't have many events, running up to 20 captures makes sense.
      </p>
    </div>
);
